<section class="time-line-box">
    <div class="swiper-container text-center">
        <div class="swiper-wrapper">
            @for (item of visitsTimeline(); track $index) {
                <div class="swiper-slide">
                    <div class="timestamp">{{ item.startDate | date: Constants.monthYearDate : Constants.uaeTimezone }}</div>
                    <div class="status pointer">
                        <adaa-picture
                            [title]="item | translateToken: 'hostedCountryName'"
                            [pictureId]="item.hostedCountryId !== Constants.CONSTANT_UAE_COUNTRY_ID ? countryFlagId() : undefined"
                            [picture]="item.hostedCountryId === Constants.CONSTANT_UAE_COUNTRY_ID ? 'assets/images/uae_rounded.jpg' : ''"
                            [width]="'25px'"
                            [height]="'25px'"
                            [style]="'object-fit: cover; border-radius: 50%'"
                        />

                        <h6 [routerLink]="['/console/international-projects/visits', item.id]" class="mt-2">{{ item | translateToken: "title" }}</h6>
                    </div>
                </div>
            }
        </div>
    </div>
</section>
